import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { convertUtcDateToTimezone } from '@utils/dates/dateMethods';
import { environmentSelector } from '@selectors/commonSelectors';

export default () => {
    const localDates = useSelector(environmentSelector)?.localDates;

    return useMemo(() => {
        if (!localDates) return new Date();
        const { serverDateInUTC, timezoneOffsetMs, dstSavingsMs } = localDates;
        return convertUtcDateToTimezone(serverDateInUTC, timezoneOffsetMs, dstSavingsMs);
    }, [localDates]);
};
